import React, { useState, useEffect } from 'react';
import { API_URL } from '../../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import {
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  FormControlLabel,
  Switch,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from 'axios';

const AdminDJForm: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    bio: '',
    social_instagram: '',
    social_facebook: '',
    display_order: 0,
    active: true,
  });
  const [photoFile, setPhotoFile] = useState<File | null>(null);

  useEffect(() => {
    if (id) {
      fetchDJ();
    }
  }, [id]);

  const fetchDJ = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/djs/${id}`);
      setFormData({
        name: response.data.name,
        bio: response.data.bio || '',
        social_instagram: response.data.social_instagram || '',
        social_facebook: response.data.social_facebook || '',
        display_order: response.data.display_order,
        active: response.data.active,
      });
    } catch (error) {
      console.error('Error fetching DJ:', error);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handlePhotoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setPhotoFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    const formDataToSend = new FormData();
    
    Object.keys(formData).forEach(key => {
      formDataToSend.append(key, String((formData as any)[key]));
    });
    
    if (photoFile) {
      formDataToSend.append('djPhoto', photoFile);
    }

    try {
      if (id) {
        await axios.put(`${API_URL}/api/djs/${id}`, formDataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });
      } else {
        await axios.post(`${API_URL}/api/djs`, formDataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });
      }
      navigate('/admin/djs');
    } catch (error) {
      console.error('Error saving DJ:', error);
    }
  };

  return (
    <Paper sx={{ p: 4, background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)' }}>
      <Typography variant="h4" sx={{ mb: 4, fontWeight: 600 }}>
        {id ? 'Editar' : 'Nuevo'} DJ
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Nombre"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          sx={{ mb: 3 }}
        />

        <TextField
          fullWidth
          label="Biografía"
          name="bio"
          value={formData.bio}
          onChange={handleChange}
          multiline
          rows={4}
          sx={{ mb: 3 }}
        />

        <TextField
          fullWidth
          label="Instagram"
          name="social_instagram"
          value={formData.social_instagram}
          onChange={handleChange}
          placeholder="https://instagram.com/usuario"
          sx={{ mb: 3 }}
        />

        <TextField
          fullWidth
          label="Facebook"
          name="social_facebook"
          value={formData.social_facebook}
          onChange={handleChange}
          placeholder="https://facebook.com/usuario"
          sx={{ mb: 3 }}
        />

        <TextField
          fullWidth
          label="Orden de visualización"
          name="display_order"
          type="number"
          value={formData.display_order}
          onChange={handleChange}
          sx={{ mb: 3 }}
        />

        <FormControlLabel
          control={
            <Switch
              checked={formData.active}
              onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
              name="active"
            />
          }
          label="Activo"
          sx={{ mb: 3 }}
        />

        <Box sx={{ mb: 3 }}>
          <Button
            variant="contained"
            component="label"
          >
            Subir Foto
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={handlePhotoChange}
            />
          </Button>
          {photoFile && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {photoFile.name}
            </Typography>
          )}
        </Box>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/admin/djs')}
          >
            Volver
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
          >
            Guardar
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default AdminDJForm;